import { defineStore } from 'pinia'
import { ref } from "vue";
import { timeout } from "@/libs/helper.js";

export const useStatesStore = defineStore('states', () => {
    const loading = ref(false);
    const recentlySucceeded = ref(false);
    const recentlyFailed = ref(false);
    const validationErrors = ref({});

    const onSuccess = async () => {
        await timeout(250);
        loading.value = false;
        recentlySucceeded.value = true;
        validationErrors.value = {};

        await timeout(500);
        recentlySucceeded.value = false;
    };

    const onFail = async () => {
        await timeout(250);
        loading.value = false;
        recentlyFailed.value = true;

        await timeout(500);
        recentlyFailed.value = false;
    };

    const reset = () => {
        loading.value = false;
        recentlySucceeded.value = false;
        recentlyFailed.value = false;
        validationErrors.value = {};
    };

    return {
        validationErrors,
        loading,
        recentlySucceeded,
        recentlyFailed,
        onSuccess,
        onFail,
        reset
    }
})
